<template>
  <div>
    <template v-if="layout === 'home'">
      <template v-if="width > 600">
        <div v-for="restaurant of $options.filters.shuffle(allRestaurants, 6)" :key="restaurant.name">
          <div class="w3-col s12 m6 l4 profile" @click="viewRestaurant(restaurant)">
            <div class="card hovercard pointer">
              <div class="cardheader" v-bind:style="{'background-image': 'url('+ restaurant.imageUrl + ')','background-size':'cover'}"></div>
              <div class="info">
                <div class="bold truncate">{{restaurant.name}}</div>
                <div v-if="restaurant.displayAddress" class="eventDate truncate">{{restaurant.displayAddress}}</div>
                <div v-if="!restaurant.displayAddress" class="eventDate truncate">{{restaurant.website}}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-if="width < 601">
        <div v-for="restaurant of $options.filters.shuffle(allRestaurants, 6)" :key="restaurant.name" @click="viewRestaurant(restaurant)">
          <div class='eventItemImage' style="height:78px; width:25%; display:inline-block; vertical-align:top; margin-bottom:8px;" :style="{'background-image': 'url(' + restaurant.imageUrl + ')'}"></div>
          <div class="info" style="width:74%; height:78px; background:#fafafa; display:inline-block; vertical-align:top; padding-left:8px; padding-right:8px;">
            <h2 class="title" style="margin:12px 0 0; font-size:14pt;">{{restaurant.name}}</h2>
            <div v-if="restaurant.displayAddress" class="eventDate truncate">{{restaurant.displayAddress}}</div>
            <div v-if="!restaurant.displayAddress" class="eventDate truncate">{{restaurant.website}}</div>
          </div>
        </div>
      </template>
    </template>
    <template v-if="layout === 'admin'">
      <div class="w3-row admin">
        <div v-for="(restaurant, index) of allRestaurants" :key="index">
          <div class="w3-col s12 m6 l4 profile">
            <div class="card pointer">
              <div class="cardheader" v-bind:style="{'background-image': 'url('+ restaurant.imageUrl + ')','background-size':'cover'}"></div>
              <div class="info" style="top:0; height:40px; padding-top:8px">
                <div class="bold truncate">{{restaurant.name}}</div>
              </div>
              <div class="manageButtons w3-row">
                <div class="w3-col s6">
                  <button class="w3-button w3-block w3-dark-blue" @click="editRestaurant(restaurant)">
                    <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
                  </button>
                </div>
                <div class="w3-col s6">
                  <button class="w3-button w3-block w3-red" @click="removeRestaurant(restaurant.name, restaurant.uid)">
                    <font-awesome-icon icon="trash"></font-awesome-icon>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="layout === 'wide'">
      <template v-if="width > 600">
        <ul class="event-list" ref="dininglist">
          <li class="eventItem pointer w3-display-container" v-for="(restaurant, index) of allRestaurants" :key="index" :style="{'animation-delay': (index * .2) + 's'}" @click="viewRestaurant(restaurant)">
            <template v-if="index && ((index+1) % 4 === 0) && showAds">
              <ads type="inline"></ads>
            </template>
            <template v-else>
              <img v-if="restaurant.imageUrl !== ''" :alt="restaurant.name" :src="restaurant.imageUrl" style="cursor:pointer;" />
              <div class="info">
                <h2 class="title" style="margin-bottom:0;">{{restaurant.name}}</h2>
                <template v-if="restaurant.displayAddress">
                  <div class="truncate"><font-awesome-icon icon="map" style="margin-right:8px;"></font-awesome-icon>{{restaurant.displayAddress}}</div>
                </template>
                <p style="margin:0" class="truncate">
                  <span class="websiteLink">{{restaurant.website}}</span>
                </p>
              </div>
              <div class="social">
                <ul>
                  <li class="facebook eventAction"><a :href="share('fb', restaurant.uid)" aria-label="facebook share" target="_blank" rel="noreferrer" class="w3-display-container"><font-awesome-icon :icon="['fab', 'facebook-f']" class="w3-text-blue w3-display-middle"></font-awesome-icon></a></li>
                  <li class="twitter eventAction"><a :href="share('tw', restaurant.uid)" aria-label="twitter share" target="_blank" rel="noreferrer" class="w3-display-container"><font-awesome-icon :icon="['fab', 'twitter']" class="w3-text-light-blue w3-display-middle"></font-awesome-icon></a></li>
                  <li class="google-plus eventAction"><a :href="share('gp', restaurant.uid)" aria-label="google share" target="_blank" rel="noreferrer" class="w3-display-container"><font-awesome-icon :icon="['fab', 'google-plus']" class="w3-text-red w3-display-middle"></font-awesome-icon></a></li>
                </ul>
              </div>
            </template>
          </li>
        </ul>
      </template>
      <template v-if="width < 601">
        <div v-for="(restaurant, index) of allRestaurants" :key="index" @click="viewRestaurant(restaurant)">
          <div class='eventItemImage' style="height:78px; width:25%; display:inline-block; vertical-align:top; margin-bottom:8px;" :style="{'background-image': 'url(' + restaurant.imageUrl + ')'}"></div>
          <div class="info" style="width:74%; height:78px; background:#fafafa; display:inline-block; vertical-align:top; padding-left:8px; padding-right:8px;">
            <h2 class="title truncate" style="margin:12px 0 0; font-size:14pt;">{{restaurant.name}}</h2>
            <div v-if="restaurant.displayAddress" class="eventDate truncate">{{restaurant.displayAddress}}</div>
            <div v-if="!restaurant.displayAddress" class="eventDate truncate">{{restaurant.website}}</div>
          </div>
        </div>
      </template>
    </template>
    <template v-if="layout === 'thin'">
      <template v-if="width > 600">
        <ul class="event-list" ref="dininglist">
          <li class="eventItem pointer" v-for="(restaurant, index) of $options.filters.shuffle(allRestaurants, limit)" :key="index" :style="{'animation-delay': (index * .2) + 's'}" @click="viewRestaurant(restaurant)">
            <img v-if="restaurant.imageUrl !== ''" :alt="restaurant.name" :src="restaurant.imageUrl" style="cursor:pointer;" />
            <div class="info">
              <h2 class="title thin">{{restaurant.name}}</h2>
                <template v-if="restaurant.displayAddress">
                  <div class="truncate"><font-awesome-icon icon="map" style="margin-right:8px;"></font-awesome-icon>{{restaurant.displayAddress}}</div>
                </template>
                <p style="margin:0" class="truncate">
                  <span class="websiteLink">{{restaurant.website}}</span>
                </p>
            </div>
            <div class="social" v-if="buttons">
              <!-- TODO buttons -->
            </div>
          </li>
        </ul>
      </template>
      <template v-if="width < 601">
        <div v-for="(restaurant, index) of $options.filters.shuffle(allRestaurants, 3)" :key="index" @click="viewRestaurant(restaurant)">
          <div class='eventItemImage' style="height:78px; width:25%; display:inline-block; vertical-align:top; margin-bottom:8px;" :style="{'background-image': 'url(' + restaurant.imageUrl + ')'}"></div>
          <div class="info" style="width:74%; height:78px; background:#fafafa; display:inline-block; vertical-align:top; padding-left:8px; padding-right:8px;">
            <h2 class="title truncate" style="margin:12px 0 0; font-size:14pt;">{{restaurant.name}}</h2>
            <div v-if="restaurant.displayAddress" class="eventDate truncate">{{restaurant.displayAddress}}</div>
            <div v-if="!restaurant.displayAddress" class="eventDate truncate">{{restaurant.website}}</div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'dining',
  data() {
    return {
      width: window.innerWidth
    }
  },
  props: ['layout','limit','buttons','showAds'],
  computed: mapState([
    'allRestaurants'
  ]),
  created() {
    this.$store.dispatch('getPlaces', 'restaurant')
  },
  methods: {
    viewRestaurant(restaurant) {
      this.$store.commit('setSelectedRestaurant', restaurant)
      this.$router.push({ name: 'restaurant-details', params: {url: restaurant.url} })
      window.scrollTo(0, 0)
    },
    editRestaurant(restaurant) {
      if (!restaurant.type) {
        restaurant.type = 'restaurant'
      }
      this.$emit('editPlace', restaurant)
    },
    removeRestaurant(name, id) {
      let data = {
        name: name,
        id: id,
        type: 'restaurant'
      }
      this.$emit('removePlace', data)
    },
    pageNav(page) {
      this.$emit('pageNav', page)
    },
    share(type, uid) {
      let sharePage = ""
      if (type === 'fb') {
        sharePage = encodeURI("https://www.facebook.com/sharer.php?u=https://daytonalocal.com/event/" + uid);
      } else if (type === 'tw') {
        sharePage = encodeURI("https://twitter.com/intent/tweet?url=https://daytonalocal.com/event/" + uid);
      } else if (type === 'gp') {
        sharePage = encodeURI("https://plus.google.com/share?url=https://daytonalocal.com/event/" + uid);
      } else {
        // nothing
      }
      return sharePage;
    }
  }
}
</script>

<style scoped>
/* Social Right Buttons */
.facebook a, .twitter a, .google-plus a {display: block; width: 100%;}
.facebook a {color: #61892F !important;}
.twitter a {color: rgb(61, 175, 204) !important;}
.google-plus a {color: rgb(221, 75, 57) !important;}
.facebook:hover a {color: rgb(255, 255, 255) !important; background-color: #61892F !important;}
.twitter:hover a {color: rgb(255, 255, 255) !important; background-color: rgb(61, 175, 204) !important;}
.google-plus:hover a {color: rgb(255, 255, 255) !important; background-color: rgb(221, 75, 57) !important;}

/* Restaurants */
.restaurant-list {display:grid; grid-template-columns: 1fr 1fr 1fr; grid-gap:8px 8px;}
.restaurantItem {background:#f5f5f5; text-align:center; position:relative; padding-bottom:40px; box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);}
.restaurantItem h2 {font-size:11pt; margin:16px 0 8px;}
.restaurantItem p {font-size:9pt; margin:0 8px}

.social {position:absolute; bottom:0; right:0; width:100%;}

.admin .w3-button {font-size:10pt; padding:6px 15px;}
</style>
